import { Dialog, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import FormInput from "../../molecules/FormInput";
import useRefresh from "../../../hooks/useRefresh";
import FormTemplate from "../../templates/FormTemplate";
import { ContactService } from "../../../services/api";
import { useTranslation } from "react-i18next";
import { Address, GeoLocation } from "../../../services/swagger";
import { useBusinessStore } from "../../../stores/Dummy";

interface CreateContactDialogProps {
  open: boolean;
  onSubmit?: () => void;
  onClose?: () => void;
}

export default function CreateContactDialog(props: CreateContactDialogProps) {
  const { t } = useTranslation("Contact");
  const refresh = useRefresh();
  const [company, setCompany] = useState("");
  const [title, setTitle] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phones, setPhones] = useState<string[]>([]);
  const [position, setPosition] = useState("");
  const [extRef, setExtRef] = useState("");

  const miniCompanyList = useBusinessStore((state) => state.miniCompanyList);

  useEffect(() => {
    if (!props.open) return;
    setCompany("");
    setTitle("");
    setFirstName("");
    setMiddleName("");
    setLastName("");
    setEmail("");
    setPhones([]);
    setPosition("");
    setExtRef("");
  }, [props.open]);

  const handleSubmit = async () => {
    const res = await ContactService.createContact({
      createContactBody: {
        company,
        addresses: [],
        email,
        extRef,
        firstName,
        lastName,
        middleName,
        phones,
        position,
        title,
      },
    });
    if (res?.data?.success) {
      refresh();
      props.onClose?.();
    }
  };
  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <FormTemplate
        title={t("CreateContact")}
        onSubmit={handleSubmit}
        onCancel={props.onClose}
        confirm
      >
        <Stack spacing={2} sx={{ minWidth: { xs: 350, sm: 400, md: 500 } }}>
          <FormInput
            field="company"
            label={t("Company")}
            onChange={(v) => {
              setCompany(v as string);
            }}
            type="list"
            list={[
              {
                name: "—",
                value: "",
              },
              ...miniCompanyList.map?.((company) => ({
                name: company.name,
                value: company._id,
              })),
            ]}
            value={company}
          />
          <FormInput
            field="title"
            label={t("Title")}
            onChange={(v) => {
              setTitle(v as string);
            }}
            type="string"
            value={title}
          />
          <FormInput
            field="firstName"
            label={t("FirstName")}
            onChange={(v) => {
              setFirstName(v as string);
            }}
            type="string"
            value={firstName}
          />
          <FormInput
            field="middleName"
            label={t("MiddleName")}
            onChange={(v) => {
              setMiddleName(v as string);
            }}
            type="string"
            value={middleName}
          />
          <FormInput
            field="lastName"
            label={t("LastName")}
            onChange={(v) => {
              setLastName(v as string);
            }}
            type="string"
            value={lastName}
          />
          <FormInput
            field="email"
            label={t("Email")}
            onChange={(v) => {
              setEmail(v as string);
            }}
            type="string"
            value={email}
          />
          <FormInput
            field="phones"
            label={t("Phones")}
            onChange={(v) => {
              setPhones(v as string[]);
            }}
            type="chip-list"
            value={phones}
          />
          <FormInput
            field="position"
            label={t("Position")}
            onChange={(v) => {
              setPosition(v as string);
            }}
            type="string"
            value={position}
          />
          <FormInput
            field="extRef"
            label={t("ExtRef")}
            onChange={(v) => {
              setExtRef(v as string);
            }}
            type="string"
            value={extRef}
          />
        </Stack>
      </FormTemplate>
    </Dialog>
  );
}
